export const visit = (vm, at) => {
vm(require("foundations-components/lang/cs.lyaml"));
at({ "cs": { "placeholder": "placeholder" } });
};